jQuery(document).ready(function($) {
  /** Home Testimonials */
  $('.testimonial-quote .quote-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100,
    adaptiveHeight: true,
    asNavFor: '.testimonial-image .image-slider',
    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20.0002 8.00073L12.0002 16.0007L20.0002 24.0007" stroke="currentColor" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12 24L20 16L12 8" stroke="currentColor" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });
  
  $('.testimonial-image .image-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '.testimonial-quote .quote-slider',     
      arrows: false,
      dots: false,
  });

  /** Product side option tab */
  $('.side-options-part .tab-head').on('click', function() {
    var $this = $(this),
        id = $this.attr('id');
      
    $('.side-options-part .tab-head').removeClass('active');
    $('.side-options-part .part-content .tab-item').removeClass('active');

    $this.addClass('active');
    $('.side-options-part .part-content .tab-item[data-id="'+ id +'"]').addClass('active');
  });

  $('[data-upsell-option-selector] input[type="radio"]').on('change', function() {
    var $this = $(this),
        itemContainer = $this.parents('.item-body'),
        variantOptions = itemContainer.find('[data-upsell-option-selector]'),
        availableOptions = itemContainer.find('.upsell-item-variant-id'),
        selectedVals = [];

    variantOptions.each(function() {
      var selectedVariant = $(this).find('input[type="radio"]:checked');
      selectedVals.push(selectedVariant.val());
    });

    availableOptions.find('option').each(function() {
      var optionList = $(this).data('option').split(','),
          variantSelected = true;
      
      $.each(optionList, function( key, value ) {
        var index = $.inArray( value, selectedVals );

        if( index == -1 ) {
          variantSelected = false;
          return;
        }
      });

      if ( variantSelected ) availableOptions.val($(this).val());
    });
  });

  $('.upsell-item-check-slide').on('change', function() {
    var $this = $(this),
        id = $this.attr('id'),
        price = parseFloat($this.data('price')),
        toggleCheckVal = $this.data('toggle-check'),
        originalPrice = parseFloat($('.buy-buttons .button .price').eq(0).text().replace('$', '')),
        calculatedPrice = 0;
    
    if ( $this.is(':checked') ) {
      $this.parents('.upsell-item').find('.item-body').addClass('enabled').slideDown();
      calculatedPrice = originalPrice + price;

      $('.buy-buttons .button .price').text('$' + calculatedPrice.toFixed(2));

      var toggleInput = $('.upsell-item-check-slide[data-toggle-check="'+ toggleCheckVal +'"]:not(#'+ id +')');
      if ( toggleInput.is(':checked') ) {
        toggleInput.prop( "checked", false ).trigger('change');
      }
    } else {
      $this.parents('.upsell-item').find('.item-body').removeClass('enabled').slideUp();
      calculatedPrice = originalPrice - price;
      $('.buy-buttons .button .price').text('$' + calculatedPrice.toFixed(2));
    }
  });

  $('.personal-text[type="number"]').on('input', function() {
    var $this = $(this),
        value = $this.val(),
        maxVal = parseInt($this.attr('max'));

    if ( value > maxVal ) $(this).val(maxVal);
  });

  $('.personal-text[type="number"]').keyup(function () {
    this.value = this.value.replace(/[^0-9\.]/g,'');
  });

  $(document).on('variant:change', function(e) {
    var selectedVariant = e.originalEvent.detail.variant,
        price = selectedVariant.price,
        plusPrice = 0;
    
    $('.upsell-item-check-slide:checked').each(function() {
      var $this = $(this),
          price = parseFloat($this.data('price'));

      plusPrice = plusPrice + price;
    });

    var finalPrice = (price / 100) + plusPrice;
    $('.buy-buttons .button').append('<span class="price" data-price="'+ finalPrice +'">$'+ finalPrice.toFixed(2) +'</span>');

    /** Hide options */
    if ( selectedVariant.name.includes('HouseMark Address Plaques') ) {
      $("#small-housemark-address-numbers").prop("checked", false).trigger('change');
      $("#large-housemark-address-numbers").prop("checked", false).trigger('change');
      $('.other-option-part .upsell-item[data-id=8171539857570]').addClass('hide');
      $('.other-option-part .upsell-item[data-id=8171539726498]').addClass('hide');
      
      if ( selectedVariant.option1.includes('Small') ) {
        $('.other-option-part .upsell-item[data-id=8171539857570]').removeClass('hide');
      } else if ( selectedVariant.option1.includes('Large') ) {
        $('.other-option-part .upsell-item[data-id=8171539726498]').removeClass('hide');
      }
    }
  });
});